export const ACTIONS: { [key: string]: string } = {
    LOGIN: "LOGIN",
    LOADING: "LOADING",
    OPENMODAL: "OPENMODAL",
    SETHEADER: "SETHEADER",
    USERINFO: "USERINFO",
    PAGE: "PAGE",
    FILTER: "FILTER",
    COMBO: "COMBO",
    SET_PROFILE_SCORE: "SET_PROFILE_SCORE",
    SHOW_SETUP_MODAL: "SHOW_SETUP_MODAL"
}

export const setLoading = (loading: boolean) => ({ type: "LOADING", loading: true })

export const setProfileScore = (score: number) => {
  localStorage.setItem('profileScore', JSON.stringify(score));
 
  return {
    type: ACTIONS.SET_PROFILE_SCORE,
    payload: score
  };
};

export const showSetupModal = (show: boolean) => ({
    type: ACTIONS.SHOW_SETUP_MODAL,
    payload: show
});
